// import "./App.css";
// import {
//   BrowserRouter,
//   Navigate,
//   Outlet,
//   Route,
//   Routes,
//   useLocation,
//   useNavigate,
// } from "react-router-dom";
// import Dashboard from "./Pages/Dashboard/Dashboard";
// import Customer from "./Pages/Customer/Customer";
// import CreateCustomer from "./Pages/CreateCustomer/CreateCustomer";
// import Login from "./Pages/Login/Login";
// import Otp from "./Pages/Otp/Otp";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import {
//   ProtectedRoutes,
//   ProtectedRoutesforLoggedIn,
//   useDecodeToken,
// } from "./Utils/function";
// import Audits from "./Pages/Audits/Audits";
// import NotFound from "./Components/NotFound/NotFound";
// import CENpage from "./Pages/CEN/CENpage";
// import Admin from "./Pages/Admins/Admin";
// import CreateAdmin from "./Pages/Admins/CreateAdmin/CreateAdmin";
// import Users from "./Pages/Users/Users";
// import CreateUser from "./Pages/Users/CreateUser/CreateUser";
// import CreateCen from "./Pages/CEN/CreateCen/CreateCen";
// import Layout from "./Components/Layout/Layout";
// import CreateCentre from "./Pages/MasterData/Centre/CreateCentre/CreateCentre";
// import Centre from "./Pages/MasterData/Centre/Centre";
// import RrbPage from "./Pages/MasterData/Rrb/RrbPage";
// import CreateRrb from "./Pages/MasterData/Rrb/CreateRrb/CreateRrb";
// import StatePage from "./Pages/MasterData/State/StatePage";
// import CreateState from "./Pages/MasterData/State/CreateState/CreateState";
// import CityPage from "./Pages/MasterData/City/CityPage";
// import CreateCity from "./Pages/MasterData/City/CreateCity/CreateCity";
// import ViewAudit from "./Pages/Audits/ViewAudit/ViewAudit";
// import AuditForm from "./Pages/AuditsQuestions/AuditsForm/AuditForm";
// import AuditsQuestions from "./Pages/AuditsQuestions/AuditsQuestions";
// import SupportTicket from "./Pages/SupportTicket/SupportTicket";
// import ReAudits from "./Pages/Re-Audits/ReAudits";
// import AuditsImages from "./Pages/AuditsImages/AuditsImages";
// import CreateAuditsImages from "./Pages/AuditsImages/CreateAuditsImages/CreateAuditsImages";
// import AuditsFormExtras from "./Pages/AuditsFormExtras/AuditsFormExtras";
// import CreateAuditsFormExtras from "./Pages/AuditsFormExtras/CreateAuditsFormExtras/CreateAuditsFormExtras";
// import PartialApprove from "./Pages/Audits/ViewAudit/PartialApprove/PartialApprove";
// import ECAAudit from "./Pages/ECAAudit/ECAAudit";
// import { useEffect } from "react";
// import ECAAuditsList from "./Pages/ECAAuditsList/ECAAuditsList";
// import ViewECAAuditList from "./Pages/ECAAuditsList/ViewECAAuditsList/ViewECAAuditsList";
// import DuplicateAudits from "./Pages/DuplicateAudit/DuplicateAudits";
// function App() {
//   const decodedToken = useDecodeToken();

//   return (
//     <div className="wrapper">
//       <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
//         <Routes>
//           <Route element={<ProtectedRoutesforLoggedIn />}>
//             <Route path="/login" element={<Login />} />
//             {/* <Route path="/otp" element={<Otp />} /> */}
//           </Route>
//           <Route element={<ProtectedRoutes />}>
//             <Route path="/" element={<Dashboard />} />
//             <Route path="/eca-audits" element={<ECAAuditsList />} />
//             {decodedToken?.role == 5 && (
//               <>
//                 <Route path="/master-data/centre" element={<Centre />} />

//                 <Route path="/ecaaudit/:id" element={<ECAAudit/>} />
//                 <Route path="/eca-audits/view-eca-audit/:id" element={<ViewECAAuditList />} />
//                 <Route
//                   path="/audits/partial-approve/:id"
//                   element={<PartialApprove />}
//                 />
//               </>
//             )}
//             {(decodedToken?.role == 3 ||
//               decodedToken?.role == 4 ||
//               decodedToken?.role == 1) && (
//               <>
//               <Route path="/duplicate-audits" element={<DuplicateAudits/>}/>
//                 <Route path="/customer" element={<Customer />} />
//                 <Route path="/audits" element={<Audits />} />
//                 <Route path="/audits/view-audit/:id" element={<ViewAudit />} />
//                 <Route
//                   path="/audits/partial-approve/:id"
//                   element={<PartialApprove />}
//                 />
//                 <Route path="/create" element={<CreateCustomer />} />
//                 <Route path="/create-auditor" element={<CreateUser />} />
//                 <Route path="/update-auditor/:id" element={<CreateUser />} />
//                 {/* <Route path="/create-cen" element={<CreateCen />} /> */}
//                 {/* <Route path="/update-cen/:id" element={<CreateCen />} /> */}
//                 <Route path="/auditors" element={<Users />} />
//                 <Route path="/cen" element={<CENpage />} />
//                 <Route path="/master-data/centre" element={<Centre />} />
//                 <Route
//                   path="/master-data/create-centre"
//                   element={<CreateCentre />}
//                 />
//                 <Route
//                   path="/master-data/update-centre/:id"
//                   element={<CreateCentre />}
//                 />
//                 <Route path="/master-data/state" element={<StatePage />} />
//                 <Route
//                   path="/master-data/create-state"
//                   element={<CreateState />}
//                 />
//                 <Route
//                   path="/master-data/update-state/:id"
//                   element={<CreateState />}
//                 />
//                 <Route path="/master-data/city" element={<CityPage />} />
//                 <Route
//                   path="/master-data/create-city"
//                   element={<CreateCity />}
//                 />
//                 <Route
//                   path="/master-data/update-city/:id"
//                   element={<CreateCity />}
//                 />
//                 <Route path="/support-ticket" element={<SupportTicket />} />
//                 <Route path="/re-audits" element={<ReAudits />} />
//                 <Route path="*" element={<NotFound />} />
//               </>
//             )}
//             {(decodedToken?.role == 3 || decodedToken?.role == 4) && (
//               <>
//                 <Route path="/admins" element={<Admin />} />
//                 <Route path="/create-admin" element={<CreateAdmin />} />
//                 <Route path="/update-admin/:id" element={<CreateAdmin />} />
//                 <Route path="/master-data/create-rrb" element={<CreateRrb />} />
//                 <Route
//                   path="/master-data/update-rrb/:id"
//                   element={<CreateRrb />}
//                 />
//                 <Route path="/master-data/rrb" element={<RrbPage />} />
//                 {decodedToken?.role !== 4 && (
//                   <>
//                     <Route
//                       path="/audits-questions"
//                       element={<AuditsQuestions />}
//                     />
//                     <Route
//                       path="/create-audit-question"
//                       element={<AuditForm />}
//                     />
//                     <Route
//                       path="/update-audit-question/:id"
//                       element={<AuditForm />}
//                     />
//                     {/* <Route path="/view-audit-question/:id" element={<AuditForm/>} /> */}
//                     <Route path="/audits-images" element={<AuditsImages />} />
//                     <Route
//                       path="/create-audit-images"
//                       element={<CreateAuditsImages />}
//                     />
//                     <Route
//                       path="/update-audit-images/:id"
//                       element={<CreateAuditsImages />}
//                     />
//                     <Route
//                       path="/audits-extras"
//                       element={<AuditsFormExtras />}
//                     />
//                     <Route
//                       path="/create-audit-extras"
//                       element={<CreateAuditsFormExtras />}
//                     />
//                     <Route
//                       path="/update-audit-extras/:id"
//                       element={<CreateAuditsFormExtras />}
//                     />
//                   </>
//                 )}
//                 <Route path="*" element={<NotFound />} />
//               </>
//             )}
//           </Route>
//         </Routes>
//         <ToastContainer />
//       </BrowserRouter>
//     </div>
//   );
// }

// export default App;

import "./App.css";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Customer from "./Pages/Customer/Customer";
import CreateCustomer from "./Pages/CreateCustomer/CreateCustomer";
import Login from "./Pages/Login/Login";
import Otp from "./Pages/Otp/Otp";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ProtectedRoutes,
  ProtectedRoutesforLoggedIn,
  RoleProtectedRoute,
  useDecodeToken,
} from "./Utils/function";
import Audits from "./Pages/Audits/Audits";
import NotFound from "./Components/NotFound/NotFound";
import CENpage from "./Pages/CEN/CENpage";
import Admin from "./Pages/Admins/Admin";
import CreateAdmin from "./Pages/Admins/CreateAdmin/CreateAdmin";
import Users from "./Pages/Users/Users";
import CreateUser from "./Pages/Users/CreateUser/CreateUser";
import CreateCen from "./Pages/CEN/CreateCen/CreateCen";
import Layout from "./Components/Layout/Layout";
import CreateCentre from "./Pages/MasterData/Centre/CreateCentre/CreateCentre";
import Centre from "./Pages/MasterData/Centre/Centre";
import RrbPage from "./Pages/MasterData/Rrb/RrbPage";
import CreateRrb from "./Pages/MasterData/Rrb/CreateRrb/CreateRrb";
import StatePage from "./Pages/MasterData/State/StatePage";
import CreateState from "./Pages/MasterData/State/CreateState/CreateState";
import CityPage from "./Pages/MasterData/City/CityPage";
import CreateCity from "./Pages/MasterData/City/CreateCity/CreateCity";
import ViewAudit from "./Pages/Audits/ViewAudit/ViewAudit";
import AuditForm from "./Pages/AuditsQuestions/AuditsForm/AuditForm";
import AuditsQuestions from "./Pages/AuditsQuestions/AuditsQuestions";
import SupportTicket from "./Pages/SupportTicket/SupportTicket";
import ReAudits from "./Pages/Re-Audits/ReAudits";
import AuditsImages from "./Pages/AuditsImages/AuditsImages";
import CreateAuditsImages from "./Pages/AuditsImages/CreateAuditsImages/CreateAuditsImages";
import AuditsFormExtras from "./Pages/AuditsFormExtras/AuditsFormExtras";
import CreateAuditsFormExtras from "./Pages/AuditsFormExtras/CreateAuditsFormExtras/CreateAuditsFormExtras";
import PartialApprove from "./Pages/Audits/ViewAudit/PartialApprove/PartialApprove";
import ECAAudit from "./Pages/ECAAudit/ECAAudit";
import { useEffect } from "react";
import ECAAuditsList from "./Pages/ECAAuditsList/ECAAuditsList";
import ViewECAAuditList from "./Pages/ECAAuditsList/ViewECAAuditsList/ViewECAAuditsList";
import DuplicateAudits from "./Pages/DuplicateAudit/DuplicateAudits";
import History from "./Pages/History/History";
import Announcements from "./Pages/Announcements/Announcements";
function App() {
  const decodedToken = useDecodeToken();

  return (
    <div className="wrapper">
      <BrowserRouter>
        <Routes>
          <Route element={<ProtectedRoutesforLoggedIn />}>
            <Route path="/login" element={<Login />} />
            {/* <Route path="/otp" element={<Otp />} /> */}
          </Route>
          <Route element={<ProtectedRoutes />}>
            <Route element={<RoleProtectedRoute allowedRoles={[5]} />}>
              <Route path="/eca-audits" element={<ECAAuditsList />} />
              <Route path="/ecaaudit" element={<ECAAudit />} />
              <Route
                path="/eca-audits/view-eca-audit"
                element={<ViewECAAuditList />}
              />
            </Route>
            <Route
              element={<RoleProtectedRoute allowedRoles={[5, 4, 3, 2, 1]} />}
            >
              <Route path="/master-data/centre" element={<Centre />} />
              <Route
                path="/master-data/create-centre"
                element={<CreateCentre />}
              />
              <Route
                path="/master-data/update-centre"
                element={<CreateCentre />}
              />
            </Route>
            <Route element={<RoleProtectedRoute allowedRoles={[3, 4, 1]} />}>
              <Route path="/announcement" element={<Announcements />} />
              <Route path="/" element={<Dashboard />} />
              <Route path="/duplicate-audits" element={<DuplicateAudits />} />
              <Route path="/customer" element={<Customer />} />
              <Route path="/audits" element={<Audits />} />
              <Route path="/audits/view-audit" element={<ViewAudit />} />
              <Route
                path="/audits/partial-approve/:id"
                element={<PartialApprove />}
              />

              <Route path="/create" element={<CreateCustomer />} />
              <Route path="/create-auditor" element={<CreateUser />} />
              <Route path="/update-auditor" element={<CreateUser />} />
              {/* <Route path="/create-cen" element={<CreateCen />} /> */}
              {/* <Route path="/update-cen/:id" element={<CreateCen />} /> */}
              <Route path="/auditors" element={<Users />} />

              <Route path="/master-data/state" element={<StatePage />} />
              <Route
                path="/master-data/create-state"
                element={<CreateState />}
              />
              <Route
                path="/master-data/update-state"
                element={<CreateState />}
              />
              <Route path="/master-data/city" element={<CityPage />} />
              <Route path="/master-data/create-city" element={<CreateCity />} />
              <Route path="/master-data/update-city" element={<CreateCity />} />
              <Route path="/support-ticket" element={<SupportTicket />} />
              <Route path="/re-audits" element={<ReAudits />} />
              <Route path="/history" element={<History />} />
              <Route path="/admins" element={<Admin />} />
              <Route path="/create-admin" element={<CreateAdmin />} />
              <Route path="/update-admin" element={<CreateAdmin />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route element={<RoleProtectedRoute allowedRoles={[3, 4]} />}>
              <Route path="/cen" element={<CENpage />} />

              <Route path="/master-data/create-rrb" element={<CreateRrb />} />
              <Route
                path="/master-data/update-rrb/:id"
                element={<CreateRrb />}
              />
              <Route path="/master-data/rrb" element={<RrbPage />} />
              {decodedToken?.role !== 4 && (
                <>
                  <Route
                    path="/audits-questions"
                    element={<AuditsQuestions />}
                  />
                  <Route
                    path="/create-audit-question"
                    element={<AuditForm />}
                  />
                  <Route
                    path="/update-audit-question"
                    element={<AuditForm />}
                  />
                  {/* <Route path="/view-audit-question/:id" element={<AuditForm/>} /> */}
                  <Route path="/audits-images" element={<AuditsImages />} />
                  <Route
                    path="/create-audit-images"
                    element={<CreateAuditsImages />}
                  />
                  <Route
                    path="/update-audit-images"
                    element={<CreateAuditsImages />}
                  />
                  <Route path="/audits-extras" element={<AuditsFormExtras />} />
                  <Route
                    path="/create-audit-extras"
                    element={<CreateAuditsFormExtras />}
                  />
                  <Route
                    path="/update-audit-extras"
                    element={<CreateAuditsFormExtras />}
                  />
                </>
              )}
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </div>
  );
}

export default App;
